<template>
  <v-dialog v-model="dialog" width="800px" @click:outside="cancel" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card class="overflow-hidden">
      <v-card-title class="primary white--text">
        <v-toolbar-title>CHI TIẾT CÂU lạc bộ</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-row cols="12" md="12" class="pt-3 pl-5 pb-10">
        <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray">
            Số lượng học sinh tối đa
          </v-col>
          <v-col cols="12" md="8" class="pb-0 text-sm-body-4">
            {{ club.maxMembers }}
          </v-col>
        </v-col>
        <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray">
            Mô tả
          </v-col>
          <v-col cols="12" md="8" class="pb-0 text-sm-body-4">
            {{ club.description }}
          </v-col>
        </v-col>
        <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray">
            Số học sinh tối đa
          </v-col>
          <v-col cols="12" md="8" class="pb-0 text-sm-body-4">
            {{ club.maxMembers }}
          </v-col>
        </v-col>
        <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray">
            Số học sinh hiện tại
          </v-col>
          <v-col cols="12" md="8" class="pb-0 text-sm-body-4">
            {{ club.countMembers }}
          </v-col>
        </v-col>
        <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray">
            Trạng thái
          </v-col>
          <v-chip class="mt-2" small :color="club.isOpenRegister ? 'success' : 'warning'">
            <span class="mr-1">
              {{ club.isOpenRegister ? 'Đã mở đăng kí' : 'Đang đóng đăng kí' }}
            </span>
          </v-chip>
        </v-col>
      </v-row>
      <div v-if="$auth.policies['update-club']">
        <hr color="#E0E0E0" />
        <v-col class="d-flex justify-end">
          <v-btn
            sm="12"
            outlined
            color="#0D47A1"
            class="mx-1 mt-2 mb-2"
            @click="$refs.clubDialog.openDialog('update', club)"
          >
            Sửa thông tin chi tiết
          </v-btn>
        </v-col>
      </div>
      <ClubDialog ref="clubDialog" />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import ClubDialog from '../club/ClubDialog.vue'
export default {
  components: { ClubDialog },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapState({
      club: state => state.club.item
    })
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    cancel() {
      this.dialog = false
    }
  }
}
</script>

<style></style>
